import {useCallback, useRef, useSyncExternalStore} from 'react'

interface ElementWidth {
  offsetWidth?: number
  clientWidth?: number
}

const getElementWidth = ({offsetWidth, clientWidth}: HTMLElement): ElementWidth => ({
  offsetWidth,
  clientWidth,
})

const SERVER_SNAPSHOT: ElementWidth = {offsetWidth: 1280, clientWidth: 1280}

function getServerSnapshot() {
  return SERVER_SNAPSHOT
}

export function useElementWidth(element: HTMLElement | null): ElementWidth {
  const sizesCacheRef = useRef<ElementWidth>({})

  const subscribeToResize = useCallback(
    (notify: () => void) => {
      if (!element) return () => undefined
      const observer = new ResizeObserver(notify)
      observer.observe(element)
      return () => {
        observer.unobserve(element)
        observer.disconnect()
      }
    },
    [element],
  )

  const getClientSnaphsot = useCallback(() => {
    if (!element) return sizesCacheRef.current
    const newSizes = getElementWidth(element)
    if (isEqual(newSizes, sizesCacheRef.current)) return sizesCacheRef.current
    sizesCacheRef.current = newSizes
    return newSizes
  }, [element])

  return useSyncExternalStore(subscribeToResize, getClientSnaphsot, getServerSnapshot)
}

function isEqual(lhs: ElementWidth, rhs: ElementWidth): boolean {
  return lhs.offsetWidth === rhs.offsetWidth && lhs.clientWidth === rhs.clientWidth
}
